export default __webpack_public_path__ + "static/media/login-icon.ee375f61.svg";